type Locales = 'ru-RU';

export type NumberLocaleOptions = {
  locales?: Locales | Locales[];
  options?: Intl.NumberFormatOptions;
};

export const numberToLocaleString = (
  value: number,
  { locales, options }: NumberLocaleOptions
) => value.toLocaleString(locales, options);
